var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-section cl-container"},[_c('nice-stats',{attrs:{"graphData":_vm.testData,"labelData":_vm.labelData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }